;(async () => {
const storeModuleURL = window.__GLOBAL__.assets.store
const module = await import(storeModuleURL)
const store = module.default
class productGallery extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
      this.thumbnails = this.querySelectorAll('.product__thumbnail');
      this.mainImage = this.querySelector('.product__main-image');
      this.enableThumbnail();
      this.enableThumbnailSlider();
      this.enableVideo();
      this.enableCompleteTheLook();
      this.enableFullscreen();
      this.mobileActive = false;
      var mainEl = this;
      if(window.matchMedia('screen and (max-width: 768px)').matches) {
          mainEl.enableMobileSlider();
          mainEl.enableFullscreenMobile();
          mainEl.mobileActive = true;
      }
      window.addEventListener("resize", function(event) {
          if(window.matchMedia('screen and (max-width: 768px)').matches && mainEl.mobileActive == false){
            mainEl.enableMobileSlider();
            mainEl.mobileActive = true;
          }
      })
    }
    enableFullscreen(){
      var desktopGallery = this.querySelector('.desktop-gallery');
      this.mainImage.querySelector('img').addEventListener("click", function(){
        desktopGallery.classList.add("fullscreen");
        document.querySelector('body').classList.add('popup-active');
        if(document.querySelector('#gorgias-chat-container')){
            document.querySelector('#gorgias-chat-container').style.display = "none";
          }
      });
      if(this.mainImage.querySelector('video')){
      this.mainImage.querySelector('video').addEventListener("click", function(){
        desktopGallery.classList.add("fullscreen");
        document.querySelector('body').classList.add('popup-active');
        if(document.querySelector('#gorgias-chat-container')){
            document.querySelector('#gorgias-chat-container').style.display = "none";
          }
      });
      }
      desktopGallery.querySelector('.action-close').addEventListener("click", function(){
        desktopGallery.classList.remove("fullscreen");
        document.querySelector('body').classList.remove('popup-active');
        if(document.querySelector('#gorgias-chat-container')){
            document.querySelector('#gorgias-chat-container').style.display = "block";
          }
      });
    }
    enableFullscreenMobile(){
      var mobileGallery = this.querySelector('.mobile-gallery');
      var popup = this.querySelector('.mobile-gallery-popup');
      function addImageSrc(){
        popup.querySelectorAll('.product__secondary-image img').forEach((imgItem) => {
                  var srcSet = imgItem.getAttribute('data-srcset');
            var src = imgItem.getAttribute('data-src');
            if(srcSet != ''){
              imgItem.setAttribute('srcset', srcSet)
            }
            if(src != ''){
              imgItem.setAttribute('src', src);
            }
            imgItem.style.display = "block";
      });
      }
        mobileGallery.querySelectorAll('.product__secondary-image img').forEach((imgItem) => {
          imgItem.addEventListener("click", function(){
          addImageSrc();
          popup.classList.add("show");
          document.querySelector('body').classList.add('popup-active');
          if(document.querySelector('#gorgias-chat-container')){
            document.querySelector('#gorgias-chat-container').style.display = "none";
          }
      });
      });
      mobileGallery.querySelector('.product__main-image img').addEventListener("click", function(){
          addImageSrc();
          popup.classList.add("show");
          document.querySelector('body').classList.add('popup-active');
        if(document.querySelector('#gorgias-chat-container')){
            document.querySelector('#gorgias-chat-container').style.display = "none";
          }
      });
      if(mobileGallery.querySelector('video')){
        mobileGallery.querySelector('video').addEventListener("click", function(){
        addImageSrc();
        popup.classList.add("show");
        document.querySelector('body').classList.add('popup-active');
        if(document.querySelector('#gorgias-chat-container')){
            document.querySelector('#gorgias-chat-container').style.display = "none";
          }
      });
      }
      popup.querySelector('.action-close').addEventListener("click", function(){
        popup.classList.remove("show");
        document.querySelector('body').classList.remove('popup-active');
        if(document.querySelector('#gorgias-chat-container')){
            document.querySelector('#gorgias-chat-container').style.display = "block";
          }
      });
    }
    enableThumbnail(){
      this.thumbnails.forEach((item) => {
        item.addEventListener("click", function() {
          var data = JSON.parse(item.querySelector('data').innerHTML);
          this.thumbnails.forEach((thumb) => {
          thumb.classList.remove('active');
          if(this.mainImage.querySelector('.model-copy')){
            this.mainImage.querySelector('.model-copy').remove();
          }
          if(this.mainImage.querySelector('.image-icon')){
            this.mainImage.querySelector('.image-icon').remove();
          }
          if(this.mainImage.querySelector("#main-video")){
            this.mainImage.querySelector("#main-video").style.display = "none";
            this.mainImage.querySelector("#play-button").style.display = "none";
          }
        });
          item.classList.add('active');
          if(data.video){
            var innerVideo = '<source src="'+data.src+'" type="video/mp4">';
            this.mainImage.querySelector("#main-video").innerHTML = innerVideo;
            this.mainImage.querySelector("#main-video").style.display = "block";
            this.mainImage.querySelector("#play-button").style.display = "inline-block";
          }
          else{
            this.mainImage.querySelector('img').setAttribute('srcset', data.srcSet)
            this.mainImage.querySelector('img').setAttribute('src', data.src.replace("amp;", ""));
            if(data.modelCopy != null){
              var newHtml = '<p class="model-copy">'+data.modelCopy+'</p>';
              this.mainImage.insertAdjacentHTML('beforeend', newHtml)
            }
            if(data.icon != null){
              var newHtml = '<span class="image-icon i--'+data.icon+'"></span>';
              this.mainImage.insertAdjacentHTML('afterbegin', newHtml)
            }
          }
        }.bind(this))
      });
    }
    enableVideo(){
      var video = document.querySelector('.desktop-gallery #main-video');
      var play = document.querySelector('.desktop-gallery #play-button');
      if(video){
          play.addEventListener('click', function() {
              if (play.classList.contains('play')) {
                  video.play();
                  play.classList.remove('play');
                  play.classList.add('pause');
              } else {
                  play.classList.remove('pause');
                  play.classList.add('play');
                  video.pause();
              }
          });
      };
      var video2 = document.querySelector('.mobile-gallery #main-video');
      var play2 = document.querySelector('.mobile-gallery #play-button');
      if(video2){
          play2.addEventListener('click', function() {
              if (play2.classList.contains('play')) {
                  video2.play();
                  play2.classList.remove('play');
                  play2.classList.add('pause');
              } else {
                  play2.classList.remove('pause');
                  play2.classList.add('play');
                  video2.pause();
              }
          });
      };
    }
    enableThumbnailSlider(){
      var thumbnailSlider = this.querySelector('.thumbnails');
               var slider = tns({
              "autoWidth": false,
              "items": 8,
              "gutter": 0,
              "slideBy":4,
              "mouseDrag": true,
              "swipeAngle": false,
              "container": thumbnailSlider,
              "speed": 800,
              "edgePadding": 0,
              "loop": false,
              "autoplay": false,
              "axis": "vertical"
              });
    }
    enableMobileSlider(){
      var mslider = tns({
              "items": 1,
              "gutter": 0,
              "slideBy":1,
              "mouseDrag": true,
              "swipeAngle": 30,
              "container": "product-gallery .mobile-slider",
              "speed": 800,
              "loop": false,
              "autoplay": false,
              "autoWidth": false,
              "preventScrollOnTouch": 'auto'
              });
var customizedFunction = function (info, eventName) {
  // direct access to info object
  console.log(info.slideCount, info.index);
  if(info.index == info.slideCount - 1){
    document.querySelector('product-gallery .mobile-gallery .tns-inner').classList.add('end');
  }
  else{
   document.querySelector('product-gallery .mobile-gallery .tns-inner').classList.remove('end');
  }
}

// bind function to event
mslider.events.on('indexChanged', customizedFunction);
            this.querySelector('product-gallery .mobile-gallery').classList.add('active');
      this.querySelectorAll('product-gallery .mobile-slider .product__secondary-image img').forEach((image) => {
        var srcSet = image.getAttribute('data-srcset');
        var src = image.getAttribute('data-src');
        if(srcSet != ''){
          image.setAttribute('srcset', srcSet)
        }
        if(src != ''){
          image.setAttribute('src', src);
        }
        image.style.display = "block";
      })
    }
    enableCompleteTheLook(){
      var toggle = this.querySelector('.v2-shop-the-look .mobile-title');
      var mainEl = this;
      if(toggle){
         toggle.addEventListener("click", function(){
           if(toggle.parentElement.classList.contains('active')){
             toggle.parentElement.classList.remove('active');
           }
           else{
             var recomendations = mainEl.querySelectorAll('.v2-shop-the-look nosto-recommendation-item');
             console.log(recomendations);
             toggle.parentElement.classList.add('active');
               var min_height = 0;
               recomendations.forEach((recItem) => {
                if(recItem.querySelector('.card-information__wrapper__main') != null){
                 var height = recItem.querySelector('.card-information__wrapper__main').offsetHeight;
                  if(height > min_height){
                    min_height = height;
                  }
                }
              });
              recomendations.forEach((recItem) => {
               recItem.querySelector('.card-information__wrapper__main').style.minHeight = min_height + 'px';
            });
           }
         })
      }
    }
}
customElements.define('product-gallery', productGallery);

class productInformation extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
      this.currentSize = document.querySelector('#savedSize').value;
      this.enableBIS();
      this.enableShipReturns();
      this.enableHowWhere();
      this.enableAccordions();
      this.enableWishlist();
      this.enableSizes();
      this.enableSwatches();
      this.enableStickyAtc();
      this.enableSizeGuide();
      this.displayCustomDiscount();
      this.enableCheckoutButton();
      if(this.currentSize != ''){
        this.enableAfterPay(document.querySelector('#afterPayStore').value);
        this.enableReviewLink();
      }
      if(document.querySelector('.preloved')){
        this.enablePrelove();
      }
    }
  enableReviewLink(){
    var reviewsContainer = document.querySelector('.v2-pdp-reviews');
    this.querySelector('[data-oke-container]').addEventListener('click', function(){
      window.scrollTo({
      top: reviewsContainer.offsetTop - 50,
      behavior: 'smooth'
    });
    })
  }
  displayCustomDiscount(){
    const messageContainer = this.querySelector('[data-custom-discount]');
    const discountMessage = sessionStorage.getItem('discountMessage');
    const allowedCollection = sessionStorage.getItem('applicableCollection');
    const applicableProduct = messageContainer.dataset.productCollections.indexOf(allowedCollection) > -1;

    if(discountMessage && messageContainer && applicableProduct) {
      messageContainer.innerHTML = discountMessage;
    }
  }
  enableStickyAtc(){
    document.addEventListener("scroll", function(){
    if(window.innerWidth < 768){
    var rect = document.querySelector('.product__actions.main .product-form__buttons').getBoundingClientRect();
        console.log('bottom', rect.bottom );
        console.log('window', window.innerHeight);
        console.log('top',rect.top);
        if(rect.top >= 0){
            document.querySelector('.product__sticky-cta').classList.remove('show');
            document.querySelector('body').classList.remove('active-sticky-cta');
        }
        else{
          document.querySelector('.product__sticky-cta').classList.add('show');
          document.querySelector('body').classList.add('active-sticky-cta');
        }
    }
  });
  }
  enableSwatches(){
    var mainEl = this;
    var swatches = this.querySelectorAll('[data-api-swatch]');
      for (let i = 0; i < swatches.length; i++) {
        swatches[i].onclick = function(e){
          e.preventDefault();
          var url = this.getAttribute("href") + '?view=apiv2';
          mainEl.getMain(url);
        };
      };
  }
  enableSizeGuide(){
    if(this.querySelector('.size-guide-trigger')){
      var popup = this.querySelector('#SGP_popup');
      var openTrig = this.querySelector('.size-guide-trigger');
      var openTrig2 = this.querySelector('.link-size');
      var closeButton = this.querySelectorAll('#SGP_popup .action-close');
      openTrig?.addEventListener("click", function (event) {
        event.preventDefault();
        popup.classList.add('show');
        document.querySelector("body").classList.add("popup-active");
        if(document.querySelector('#gorgias-chat-container')){
            document.querySelector('#gorgias-chat-container').style.display = "none";
          }
      });
      openTrig2?.addEventListener("click", function (event) {
        event.preventDefault();
        popup.classList.add('show');
        document.querySelector("body").classList.add("popup-active");
        if(document.querySelector('#gorgias-chat-container')){
            document.querySelector('#gorgias-chat-container').style.display = "none";
          }
      });
      closeButton.forEach(function(icon){
        icon.addEventListener("click", function (){
        popup.classList.remove('show');
        document.querySelector("body").classList.remove("popup-active");
        if(document.querySelector('#gorgias-chat-container')){
            document.querySelector('#gorgias-chat-container').style.display = "block";
          }
      });
      });
    }
  }
  togglePreloveButton(){
    var popup = this.querySelector('#PL_popup');
    var addButton = this.querySelector('#Preloved_trigger');
    var currentSize = document.querySelector("#savedSize").value;
    var currentAvailableCheck = popup.querySelectorAll('.preloved-item[data-option2="'+currentSize+'"]');
    if(currentAvailableCheck.length > 0){
            addButton.style.display = "flex";
          }
          else{
            addButton.style.display = "none";
          }
  }
  enablePrelove(){
    var mainEl = this;
    var popup = this.querySelector('#PL_popup');
    this.togglePreloveButton();
    this.preloveButtons = this.querySelectorAll(".preloved button");
    this.preloveButtons.forEach((button) => {
      button.addEventListener("click", () => {
        var addID = button.getAttribute('data-variantid');
        store.dispatch('addItems', {
        [addID]: 1
      })
      var removeMe = button.parentElement.parentElement.parentElement;
      var current = document.querySelector("#savedSize").value;
      var activeItems = popup.querySelectorAll('.preloved-item[data-option2="'+current+'"]');

      window.setTimeout(function(){
        popup.classList.remove('show');
        removeMe.remove();
        activeItems.forEach((item) => {
          item.style.display = "none";
        });
        mainEl.togglePreloveButton();
      }, 500);
      })
    });
    var closeButton = this.querySelectorAll('#PL_popup .action-close');
    var openTrig = this.querySelector('#Preloved_trigger');
      openTrig.addEventListener("click", function (event) {
        event.preventDefault();
        var current = document.querySelector("#savedSize").value;
        var activeItems = popup.querySelectorAll('.preloved-item[data-option2="'+current+'"]');
        activeItems.forEach((item) => {
          item.style.display = 'block';
        })
        popup.classList.add('show');
        document.querySelector("body").classList.add("popup-active");
        if(document.querySelector('#gorgias-chat-container')){
            document.querySelector('#gorgias-chat-container').style.display = "none";
          }
      });
    closeButton.forEach(function(icon){
        icon.addEventListener("click", function (){
        var current = document.querySelector("#savedSize").value;
        var activeItems = popup.querySelectorAll('.preloved-item[data-option2="'+current+'"]');
        activeItems.forEach((item) => {
          item.style.display = "none";
        })
        popup.classList.remove('show');
        document.querySelector("body").classList.remove("popup-active");
        if(document.querySelector('#gorgias-chat-container')){
            document.querySelector('#gorgias-chat-container').style.display = "block";
          }
      });
      });
  }

  getMain(url){
  fetch(url).then(response => response.text()).then(function(data){
    var jsonData = JSON.parse(data);
    var main_product_html = jsonData.main_product_html;
    document.querySelector('#afterPayStore').value = jsonData.afterpay;
    window.history.replaceState(null, '', jsonData.url);
    if(window.innerWidth < 768){
    window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    document.querySelector('[data-api-main]').innerHTML = main_product_html;
  });
  }
    enableAfterPay(afterpayHtml){
      this.querySelector('.product__actions.main .product-form__buttons').insertAdjacentHTML('afterend',afterpayHtml);
    }
    enableWishlist(){
    var wishlistButton = this.querySelector('.wishlist-btn')

      function swymCallbackFn() {
        if (wishlistButton) {
          _swat.fetchWrtEventTypeET(fetchCallbackFn, 4)
          // fetching all wishlist events
        }
      }

      function fetchCallbackFn(products) {
        let activeProductId = document.querySelector('#bis-product-id').value;
        let activeVariantId = document.getElementById('variantID').value;
        let isInWishlist = products.find(function (p) {
          return p.empi == activeProductId && p.epi == activeVariantId
        })

        if (isInWishlist) {
          wishlistButton.setAttribute('disabled', true)
          wishlistButton.classList.add('wishlist-btn--active')
        } else {
          wishlistButton.addEventListener('click', function (e) {
            if (SwymPageData) {
              SwymPageData.et = 4 // et 4 stands for wishlist event type
              _swat.addToWishList(SwymPageData, function (e) {
                wishlistButton.classList.add('wishlist-btn--active')
              })
            }
          })
        }
      }

      if (!window.SwymCallbacks) {
        window.SwymCallbacks = []
      }

      window.SwymCallbacks.push(swymCallbackFn)
  }
    enableSizes(){
    var mainEl = this;
    var sizes = this.querySelectorAll('variant-radios .size input');
    var current = this.querySelectorAll('variant-radios .size input:checked')[0];
    if (this.currentSize == ''){
      this.currentSize = current.value;
      document.querySelector('#savedSize').value = this.currentSize;
    }
    for (let i = 0; i < sizes.length; i++) {
        sizes[i].onclick = function(e){
          this.currentSize = sizes[i].value;
          document.querySelector('#savedSize').value = sizes[i].value;
          if(document.querySelector('.preloved')){
          mainEl.togglePreloveButton()
          }
        };
        if(sizes[i].value == this.currentSize){
          window.setTimeout(function(){
            sizes[i].click();
          }, 100)
        }
      };
    }
    enableAccordions(){
      var accordions = this.querySelectorAll('.product-accordions .single-accordion > a');
      accordions.forEach(function(accordion){
        accordion.addEventListener("click", function (event){
          if(accordion.parentElement.classList.contains('active')){
            accordion.parentElement.classList.remove('active');
            accordion.parentElement.classList.remove('animate');
          }
          else{
            accordions.forEach(function(accordion2){
              accordion2.parentElement.classList.remove('active');
              accordion2.parentElement.classList.remove('animate');
            })
            accordion.parentElement.classList.add('active');
            accordion.parentElement.classList.add('animate');
          }
      });
      });
      if(this.querySelector('.product-accordions .link-size')){
        var mainSizeGuideE = this.querySelector('.size-help details-modal summary');
        this.querySelector('.product-accordions .link-size a').addEventListener("click", function(event){
          event.preventDefault();
          mainSizeGuideE.dispatchEvent(new Event('click'));
        })
      }
      var mainEl = this;
      window.setTimeout(function(){
      if(mainEl.querySelector('.product-accordions .link-review a')){
        var mainReviews = mainEl.querySelector('.oke-is-clickable');
        mainEl.querySelector('.product-accordions .link-review a').addEventListener("click", function(event){
          event.preventDefault();
          mainReviews.dispatchEvent(new Event('click'));
        })
      }

      }, 4000)
    }
    enableHowWhere(){
      var toggleHow = this.querySelector('.how-where [data-how]');
      var toggleWhere = this.querySelector('.how-where [data-where]');
      var toggle = this.querySelector('.how-where .toggle');
      var how = this.querySelector('.how-where .how');
      var where = this.querySelector('.how-where .where');
      toggleHow.addEventListener("click", function (event){
          event.preventDefault();
          toggleHow.classList.add('active');
          how.classList.add('active');
          toggleWhere.classList.remove('active');
          where.classList.remove('active');
          toggle.classList.remove('animate-right');
          toggle.classList.add('animate-left');
        });
      toggleWhere.addEventListener("click", function (event){
          event.preventDefault();
          toggleWhere.classList.add('active');
          where.classList.add('active');
          toggleHow.classList.remove('active');
          how.classList.remove('active');
          toggle.classList.add('animate-right');
          toggle.classList.remove('animate-left');
        });
      var popup = this.querySelector('#HW_popup');
      var closeButton = this.querySelectorAll('#HW_popup .action-close');
      var hwTrig = this.querySelectorAll('.how-item');
      hwTrig.forEach((item) => {
        var data = JSON.parse(item.querySelector('data').innerHTML);
        item.addEventListener("click", function (){
          popup.querySelector('[data-title]').innerHTML = data.title;
          popup.querySelector('[data-description]').innerHTML = data.description;
          popup.querySelector('[data-img]').src = data.image.replace('amp;', '');
          popup.classList.add("show");
          document.querySelector('body').classList.add('popup-active');
          if(document.querySelector('#gorgias-chat-container')){
            document.querySelector('#gorgias-chat-container').style.display = "none";
          }
        });
      })
      closeButton.forEach(function(icon){
        icon.addEventListener("click", function (){
        popup.classList.remove("show");
        document.querySelector('body').classList.remove('popup-active');
        if(document.querySelector('#gorgias-chat-container')){
            document.querySelector('#gorgias-chat-container').style.display = "block";
          }
      });
      });
    }
    enableShipReturns(){
      var popup = this.querySelector('#SRI_popup');
      var closeButton = this.querySelectorAll('#SRI_popup .action-close');
      var shipTrig = this.querySelector('.ship-returns-info .free-shipping');
      var returnTrig = this.querySelector('.ship-returns-info .free-returns');
      shipTrig.addEventListener("click", function (event) {
        event.preventDefault();
        popup.classList.add('show');
        popup.classList.add("shipping");
        popup.classList.remove("returns");
        document.querySelector('body').classList.add('popup-active');
        if(document.querySelector('#gorgias-chat-container')){
            document.querySelector('#gorgias-chat-container').style.display = "none";
          }
      });
      returnTrig.addEventListener("click", function (event) {
        event.preventDefault();
        popup.classList.add('show');
        popup.classList.add("returns");
        popup.classList.remove("shipping");
        document.querySelector('body').classList.add('popup-active');
        if(document.querySelector('#gorgias-chat-container')){
            document.querySelector('#gorgias-chat-container').style.display = "none";
          }
      });
      closeButton.forEach(function(icon){
        icon.addEventListener("click", function (event){
          event.preventDefault();
        popup.classList.remove('show');
          document.querySelector('body').classList.remove('popup-active');
        if(document.querySelector('#gorgias-chat-container')){
            document.querySelector('#gorgias-chat-container').style.display = "block";
          }
      });
      });
    }
    intlPhoneNumberSelector() {
      if(!window.intlTelInput) {
        setTimeout(() => {
          this.intlPhoneNumberSelector();
        }, 200)
      } else {
        const bisPhone = window.intlTelInput(this.querySelector('input[type="tel"]'), {
          initialCountry: Shopify.country,
          geoIpLookup: true,
          containerClass: 'hidden',
          loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js"),
        })

        return bisPhone;
      }
    }
    enableBIS(){
      var popup = this.querySelector('#BISC_rxpop');
      var popupForm = this.querySelector('#BISC_form');
      var emailButton = this.querySelector('.notif-type #emailButton');
      var smsButton = this.querySelector('.notif-type #smsButton');
      var emailInput = this.querySelector('#email_address');
      var smsInput = this.querySelector('#phone');
      var variantInput = this.querySelector('#bis-variants');
      var smsWrap = this.querySelector('.smsWrap');
      var closeButton = this.querySelectorAll('#BISC_rxpop .action-close');
      var phoneInput = window.intlTelInput(this.querySelector('input[type="tel"]'), {
        initialCountry: Shopify.country,
        loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js"),
      });
      var input = document.getElementById('variantID');
      var notiftyTrig = this.querySelector('.product-form #BISC_trigger');
      input.addEventListener('change', function() {
        checkSoldOut();
      });
      function checkSoldOut(){
        var isSoldOut = false;
        for (var i = 0; i < variantInput.length; ++i){
              if (variantInput.options[i].value == input.value){
                isSoldOut = true;
              }
          }
        if(isSoldOut){
          notiftyTrig.style.display = "block";
        }
        else{
          notiftyTrig.style.display = "none";
        }
      }
      checkSoldOut();
      closeButton.forEach(function(icon){
        icon.addEventListener("click", function (){
        popup.style.display = 'none';
      });
      });
      notiftyTrig.addEventListener("click", function () {
        popup.style.display = 'block';
        variantInput.value = input.value;
      });
      emailButton.addEventListener("click", function () {
        if(!this.classList.contains('active')){
          this.classList.add('active');
          emailInput.classList.add('active');
          emailInput.setAttribute("required", "");
          smsInput.classList.remove('active');
          smsInput.removeAttribute("required");
          smsButton.classList.remove('active');
          smsWrap.classList.remove('active');
        }
      });
      smsButton.addEventListener("click", function () {
        if(!this.classList.contains('active')){
          this.classList.add('active');
          emailInput.classList.remove('active');
          emailInput.removeAttribute("required");
          smsInput.classList.add('active');
          smsWrap.classList.add('active');
          smsInput.setAttribute("required", "");
          emailButton.classList.remove('active');
        }
      });
      popupForm.onsubmit = function(e){
        e.preventDefault();
        var emailBIS = emailInput.value;
        var smsBIS = phoneInput.getNumber();
        var variantBIS = variantInput.value;
        var productBIS = document.querySelector('#bis-product-id').value;
        document.querySelector("#BISC_rxpop .completed_message").style.display = "none";
        document.querySelector("#BISC_rxpop #message_holder").style.display = "none";
        if(emailButton.classList.contains('active')){
        BIS.create(emailBIS, variantBIS, productBIS).then(notificationCallback);
        }
        else{
          BIS.create(null, variantBIS, productBIS, { phone_number: smsBIS }).then(notificationCallback);
        }
      }
      var notificationCallback = function(data) {
          var msg = '';
          if (data.status == 'OK') {
            document.querySelector("#BISC_rxpop .completed_message").style.display = "block";
          } else { // it was an error
            for (var k in data.errors) {  // collect all the error messages into a string
               msg += (data.errors[k].join());
             }
             document.querySelector("#BISC_rxpop #message_holder").innerHTML = '<p class="alert alert-danger">'+msg+'</p>';
            document.querySelector("#BISC_rxpop #message_holder").style.display = "block";
          }
        }
  }

  enableCheckoutButton() {
    const checkoutBtns = document.querySelectorAll('[name="buy-now"]');
    const variantEl = document.querySelector('#variantID');
    checkoutBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        document.location.href = `${Shopify.routes.root}cart/${variantEl.value}:1`
      })
    })
  }
}
customElements.define('product-information', productInformation);
})()